import { TranslationKey } from "../i18n/translation-key"

export interface ReviewStats {
  averageRating: number
  totalReviews: number
  ratingDistribution: RatingDistributionStat[]
}

export interface RatingDistributionStat {
  rating: number
  count: number
}

export enum ReviewPeriod {
  THIS_WEEK = "THIS_WEEK",
  THIS_MONTH = "THIS_MONTH",
  LAST_SIX_MONTHS = "LAST_SIX_MONTHS",
  LAST_YEAR = "LAST_YEAR",
  FOREVER = "FOREVER",
}

export interface ReviewStatsFilters {
  storeId: string
  period: ReviewPeriod
}

export interface ReviewPeriodLabelKeys {
  nameKey: TranslationKey
  shortNameKey: TranslationKey
}

const REVIEW_PERIOD_LABEL_KEYS: Record<ReviewPeriod, ReviewPeriodLabelKeys> = {
  [ReviewPeriod.THIS_WEEK]: {
    nameKey: "common.reviewPeriod.thisWeek.name",
    shortNameKey: "common.reviewPeriod.thisWeek.shortName",
  },
  [ReviewPeriod.THIS_MONTH]: {
    nameKey: "common.reviewPeriod.thisMonth.name",
    shortNameKey: "common.reviewPeriod.thisMonth.shortName",
  },
  [ReviewPeriod.LAST_SIX_MONTHS]: {
    nameKey: "common.reviewPeriod.lastSixMonths.name",
    shortNameKey: "common.reviewPeriod.lastSixMonths.shortName",
  },
  [ReviewPeriod.LAST_YEAR]: {
    nameKey: "common.reviewPeriod.lastYear.name",
    shortNameKey: "common.reviewPeriod.lastYear.shortName",
  },
  [ReviewPeriod.FOREVER]: {
    nameKey: "common.reviewPeriod.forever.name",
    shortNameKey: "common.reviewPeriod.forever.shortName",
  },
}

export class ReviewPeriodUtils {
  static getPeriodLabelKeys(value: ReviewPeriod): ReviewPeriodLabelKeys {
    return REVIEW_PERIOD_LABEL_KEYS[value]
  }

  static getDateRange(period: ReviewPeriod): { start?: Date; end?: Date } {
    const now = new Date()

    switch (period) {
      case ReviewPeriod.THIS_WEEK: {
        const startOfWeek = new Date(now)
        startOfWeek.setDate(now.getDate() - now.getDay() + 1) // Monday
        startOfWeek.setHours(0, 0, 0, 0)
        return { start: startOfWeek }
      }

      case ReviewPeriod.THIS_MONTH: {
        const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1)
        return { start: startOfMonth }
      }

      case ReviewPeriod.LAST_SIX_MONTHS: {
        const sixMonthsAgo = new Date(now)
        sixMonthsAgo.setMonth(now.getMonth() - 6)
        return { start: sixMonthsAgo }
      }

      case ReviewPeriod.LAST_YEAR: {
        const oneYearAgo = new Date(now)
        oneYearAgo.setFullYear(now.getFullYear() - 1)
        return { start: oneYearAgo }
      }

      case ReviewPeriod.FOREVER:
        return {}
    }
  }
}
